import React from 'react';
import { Check } from 'lucide-react';
const benefits = [<>
    Generar ingresos <u data-id="element-206">REALES</u> desde casa{' '}
    <em className="not-italic text-brand-navy/70" data-id="element-207">(sin experiencia)</em>
  </>, <>
    Ser más <u data-id="element-208">LIBRE</u> y manejar tus tiempos, inclusive viajando
  </>, <>
    Ahorrar tiempo y dinero con un método que realmente <u data-id="element-209">FUNCIONA</u>
  </>, <>Tu cuenta bancaria se vea así todos los meses 👇🏻</>];
export function ProofSection() {
  return <section className="px-6 py-10 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-210">
      <p className="font-serif text-xl text-brand-navy mb-6 max-w-md" data-id="element-211">
        Y si yo pude, vos también podes. Por eso creé:
      </p>

      {/* Peach panel: rounded top, square bottom */}
      <div className="w-full max-w-5xl bg-[#f7e3d0] rounded-t-[3rem] rounded-b-none px-6 pt-10 pb-10 flex flex-col items-center" data-id="element-212">
        <h2 className="font-serif italic text-3xl md:text-4xl text-brand-navy mb-6 leading-tight" data-id="element-213">
          ✨ Mi programa <br data-id="element-214" /> Fórmula Ugc ✨
        </h2>

        {/* Product mockup */}
        <img src="https://cdn.magicpatterns.com/uploads/xcxk8iFKHhPrqBcr1je2uU/pasted-image.png" alt="Programa Fórmula UGC en computadora y celular" className="w-full max-w-3xl h-auto rounded-3xl shadow-lg mb-10" data-id="element-215" />

        <h3 className="font-serif text-3xl md:text-4xl text-brand-navy mb-8 leading-tight mx-auto" data-id="element-216">
          Este Programa es para vos si querés...
        </h3>

        <ul className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-217">
          {benefits.map((item, i) => <li key={i} className="flex items-start gap-3 justify-center px-2 md:justify-start" data-id="element-218">
              <Check size={20} strokeWidth={3} className="text-brand-navy shrink-0 mt-1" data-id="element-219" />
              <span className="text-brand-navy text-[17px] leading-snug max-w-[280px] text-left" data-id="element-220">
                {item}
              </span>
            </li>)}
        </ul>
      </div>

      {/* Mercado Pago balance */}
      <div className="w-full max-w-3xl -mt-1" data-id="element-221">
        <div className="border-4 border-yellow-400 overflow-hidden" data-id="element-222">
          <img src="https://cdn.magicpatterns.com/uploads/ra9e77iktzHG2Y82vKhv2z/pasted-image.jpg" alt="Saldo disponible en Mercado Pago" className="w-full h-auto block" data-id="element-223" />
        </div>
      </div>
    </section>;
}